'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isEqualWith = require('./isEqualWith.js');
var noop = require('../function/noop.js');
function isEqual(a, b) {
    return isEqualWith.isEqualWith(a, b, noop.noop);
}
exports.isEqual = isEqual;
